import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/icon/done.svg';
import _imports_1 from '../../../assets/icon/success.svg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-830286ca"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconxiangzuojiantou"
  }, null, -1);
});

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "返回", -1);
});

var _hoisted_3 = [_hoisted_1, _hoisted_2];
var _hoisted_4 = {
  class: "steps"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "title"
  }, "创建企业", -1);
});

var _hoisted_6 = {
  key: 0,
  class: "head"
};
var _hoisted_7 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
var _hoisted_8 = {
  key: 1
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "填写激活码", -1);
});

var _hoisted_10 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
var _hoisted_11 = {
  key: 1
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "确认激活信息", -1);
});

var _hoisted_13 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
var _hoisted_14 = {
  key: 1
};

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "填写企业信息", -1);
});

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "4", -1);
});

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "完成", -1);
});

var _hoisted_18 = [_hoisted_16, _hoisted_17];
var _hoisted_19 = {
  class: "step-list"
};
var _hoisted_20 = {
  key: 0,
  class: "step step1"
};
var _hoisted_21 = {
  class: "code"
};
var _hoisted_22 = {
  class: "type"
};
var _hoisted_23 = ["onClick"];

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconjianshao1"
  }, null, -1);
});

var _hoisted_25 = [_hoisted_24];

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconzengjia1"
  }, null, -1);
});

var _hoisted_27 = [_hoisted_26];
var _hoisted_28 = {
  key: 0,
  class: "error"
};

var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconinfo"
  }, null, -1);
});

var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "激活码无效", -1);
});

var _hoisted_31 = [_hoisted_29, _hoisted_30];

var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "go-buy"
  }, [/*#__PURE__*/_createTextVNode(" 购买智能增长套件产品以获取激活码 "), /*#__PURE__*/_createElementVNode("a", {
    href: "https://buy.cloud.tencent.com/tbdt",
    target: "_blank"
  }, "去购买")], -1);
});

var _hoisted_33 = /*#__PURE__*/_createTextVNode(" 下一步 ");

var _hoisted_34 = {
  class: "step step2"
};
var _hoisted_35 = {
  class: "code-detail"
};
var _hoisted_36 = {
  class: "title"
};
var _hoisted_37 = ["src"];
var _hoisted_38 = {
  class: "detail"
};
var _hoisted_39 = {
  class: "basic"
};

var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "可用时长", -1);
});

var _hoisted_41 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "可用账号数", -1);
});

var _hoisted_42 = {
  key: 0
};

var _hoisted_43 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "可用空间数", -1);
});

var _hoisted_44 = {
  class: "subtitle"
};
var _hoisted_45 = {
  key: 0,
  class: "line"
};

var _hoisted_46 = /*#__PURE__*/_createTextVNode("我已阅读并同意 ");

var _hoisted_47 = ["href"];
var _hoisted_48 = {
  class: "btns"
};

var _hoisted_49 = /*#__PURE__*/_createTextVNode("上一步");

var _hoisted_50 = /*#__PURE__*/_createTextVNode("下一步");

var _hoisted_51 = {
  class: "step step3"
};

var _hoisted_52 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", {
    class: "title"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconinfo"
  }), /*#__PURE__*/_createTextVNode("企业创建完成")]), /*#__PURE__*/_createElementVNode("p", {
    class: "desc"
  }, "创建完成后，您的激活码将被正式使用并失效，该操作不可撤销")], -1);
});

var _hoisted_53 = {
  class: "dialog-footer"
};

var _hoisted_54 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_55 = /*#__PURE__*/_createTextVNode("确认");

var _hoisted_56 = {
  class: "step step4"
};

var _hoisted_57 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});

var _hoisted_58 = {
  key: 0,
  class: "success-tip"
};
var _hoisted_59 = {
  key: 1,
  class: "success-tip"
};

var _hoisted_60 = /*#__PURE__*/_createTextVNode(" 进入企业 ");

var _hoisted_61 = /*#__PURE__*/_createTextVNode(" 返回控制台 ");

var _hoisted_62 = /*#__PURE__*/_createTextVNode(" 返回官网 ");

var _hoisted_63 = {
  class: "company-info"
};

var _hoisted_64 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "企业名称", -1);
});

var _hoisted_65 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "所属行业", -1);
});

var _hoisted_66 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "联系人", -1);
});

var _hoisted_67 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "联系电话", -1);
});

var _hoisted_68 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", {
    class: "title"
  }, "离开此页面？"), /*#__PURE__*/_createElementVNode("p", {
    class: "desc"
  }, "离开此页面将丢失已编辑的内容，是否离开？")], -1);
});

var _hoisted_69 = {
  class: "dialog-footer"
};

var _hoisted_70 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_71 = /*#__PURE__*/_createTextVNode("确认");

import { reactive, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import CompanyForm from '../Components/Form.vue';
import { appFeature, modifyTip } from '@/config/company';
import { useStore } from 'vuex';
import CompanyService from '@/api/company';
import { debounce } from '@/utils/index';
import { ElMessage } from 'element-plus';
import { computed } from '@vue/reactivity';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var isPaidCreate = window.AppConfig.corporation.createMethod === 'activateCode';
    var route = useRoute();
    var router = useRouter();
    var store = useStore();
    var step = ref(isPaidCreate ? 1 : 3);
    var newWarnVisible = ref(false);
    var leaveWarnVisible = ref(false);
    var corporationId = ref('');
    var inMicroApp = ref(window.__MICRO_APP_ENVIRONMENT__); // 激活码列表

    var codeList = reactive([]); // 产品列表

    var appData = reactive({
      appList: []
    });
    var formState = reactive({
      name: '',
      industry: 0,
      contact: '',
      phone: '',
      industryName: ''
    });
    var corporationDetail = reactive({});
    var codeLegal = computed(function () {
      return codeList.some(function (item) {
        return item.legal;
      });
    });
    var appChecked = computed(function () {
      return appData.appList.every(function (item) {
        return item.checked || !item.protocal;
      });
    });

    var goCompanyList = function goCompanyList() {
      router.push(isPaidCreate ? '/company/list' : '/groupList');
    }; // 点击返回


    var handleReturn = function handleReturn() {
      if (step.value === 1 && !codeList.length || step.value === 4) {
        return goCompanyList();
      }

      leaveWarnVisible.value = true;
    };

    var goConsole = function goConsole(path) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (window.__MICRO_APP_ENVIRONMENT__) {
        var _window, _window$microApp, _globalAPI$router;

        var _window$microApp$getD = (_window = window) === null || _window === void 0 ? void 0 : (_window$microApp = _window.microApp) === null || _window$microApp === void 0 ? void 0 : _window$microApp.getData(),
            globalAPI = _window$microApp$getD.globalAPI;

        globalAPI === null || globalAPI === void 0 ? void 0 : (_globalAPI$router = globalAPI.router) === null || _globalAPI$router === void 0 ? void 0 : _globalAPI$router.subAppPush('console', '/');
      } else {
        router.push("".concat(path).concat(query));
      }
    };

    var goCompanyAppPage = function goCompanyAppPage() {
      CompanyService.recordEnterCorporation({
        corporationId: corporationId.value
      });
      goConsole('/console', "?corp_id=".concat(corporationId.value));
    };

    var goRouter = function goRouter(path) {
      router.push(path);
    };

    var comfirmLeave = function comfirmLeave() {
      leaveWarnVisible.value = false;
      goCompanyList();
    }; // 增删激活码


    var addCode = function addCode() {
      codeList.push({
        code: '',
        name: ''
      });
    };

    var deleteCode = function deleteCode(index) {
      codeList.splice(index, 1);
    }; // 校验激活码有效性


    var checkCodeLegal = debounce( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, index) {
        var _data$data;

        var data, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('code', params.code);
                _context.next = 3;
                return CompanyService.queryActiveCode({
                  activeCodes: [params.code]
                });

              case 3:
                data = _context.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  result = data.data.result[0];

                  try {
                    codeList.splice(index, 1, _objectSpread(_objectSpread({}, params), {}, {
                      name: result.appName,
                      appKey: result.appKey,
                      legal: !!result.appName && !!result.appKey
                    }));
                  } catch (error) {
                    console.log(error);
                  }
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), 120);

    var goStep = function goStep(val) {
      step.value = val;
    };

    var goAppPage = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$data2;

        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                goStep(2);
                _context2.next = 3;
                return CompanyService.queryActiveCode({
                  activeCodes: codeList.filter(function (item) {
                    return item.legal;
                  }).map(function (item) {
                    return item.code;
                  })
                });

              case 3:
                data = _context2.sent;

                if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1) {
                  appData.appList = data.data.result.map(function (item) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                      logo: appFeature[item.appKey].logo,
                      detail: JSON.parse(item.configMap),
                      checked: false,
                      protocal: appFeature[item.appKey].protocal
                    });
                  });
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function goAppPage() {
        return _ref2.apply(this, arguments);
      };
    }(); // 点击下一步


    var checkAllCode = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var keyList;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                keyList = codeList.filter(function (item) {
                  return item.legal;
                }).map(function (item) {
                  return item.appKey;
                });

                if (!(Array.from(new Set(keyList)).length < keyList.length)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", ElMessage({
                  message: '激活码存在冲突',
                  type: 'error'
                }));

              case 3:
                goAppPage();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function checkAllCode() {
        return _ref3.apply(this, arguments);
      };
    }();

    var showCorporationInfo = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _data$data3, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                goStep(4);

                if (!isPaidCreate) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 4;
                return CompanyService.getCompanyInfo({
                  corporation_id: corporationId.value
                });

              case 4:
                data = _context4.sent;

                if (((_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.code) === 1) {
                  Object.keys(data.data.result).forEach(function (key) {
                    corporationDetail[key] = data.data.result[key];
                  });
                  corporationDetail.industryName = formState.industryName || '';
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function showCorporationInfo() {
        return _ref4.apply(this, arguments);
      };
    }(); // 确认创建企业


    var comfirmNewCompany = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _data$data4;

        var data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return store.dispatch('company/createCompany', {
                  corporationName: formState.name,
                  industryId: formState.industry,
                  contact: formState.contact,
                  phone: formState.phone,
                  creatorRole: 1,
                  scale: 1,
                  email: 'dataauth@tencent.com',
                  activeCodes: isPaidCreate ? appData.appList.map(function (item) {
                    return item.activeCode;
                  }).join(';') : ''
                });

              case 2:
                data = _context5.sent;

                if (((_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.code) === 1) {
                  corporationId.value = data.data.result;
                  newWarnVisible.value = false;
                  ElMessage({
                    message: modifyTip.applySuccess,
                    type: 'success'
                  });
                  showCorporationInfo();
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function comfirmNewCompany() {
        return _ref5.apply(this, arguments);
      };
    }(); // 点击完成


    var handleNewCompany = function handleNewCompany(data) {
      formState.name = data.name;
      formState.phone = data.phone;
      formState.contact = data.contact;
      formState.industry = data.industry || 0;
      formState.industryName = data.industryName || '';

      if (isPaidCreate) {
        newWarnVisible.value = true;
      } else {
        comfirmNewCompany();
      }
    };

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              codeList.push({
                code: '',
                name: ''
              });

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_checkbox = _resolveComponent("el-checkbox");

      var _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['new-company', inMicroApp.value && 'new-company-inMicroApp']),
        ref: "newCompany"
      }, [_createElementVNode("div", {
        class: "return",
        onClick: handleReturn
      }, _hoisted_3), _createElementVNode("div", _hoisted_4, [_hoisted_5, isPaidCreate ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
        class: _normalizeClass(["step-title", {
          active: step.value === 1,
          done: step.value > 1
        }])
      }, [step.value > 1 ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : (_openBlock(), _createElementBlock("span", _hoisted_8, "1")), _hoisted_9], 2), _createElementVNode("div", {
        class: _normalizeClass(["line", {
          done: step.value > 1
        }])
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(["step-title", {
          active: step.value === 2,
          done: step.value > 2
        }])
      }, [step.value > 2 ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : (_openBlock(), _createElementBlock("span", _hoisted_11, "2")), _hoisted_12], 2), _createElementVNode("div", {
        class: _normalizeClass(["line", {
          done: step.value > 2
        }])
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(["step-title", {
          active: step.value === 3,
          done: step.value > 3
        }])
      }, [step.value > 3 ? (_openBlock(), _createElementBlock("img", _hoisted_13)) : (_openBlock(), _createElementBlock("span", _hoisted_14, "3")), _hoisted_15], 2), _createElementVNode("div", {
        class: _normalizeClass(["line", {
          done: step.value > 3
        }])
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(["step-title", {
          active: step.value === 4
        }])
      }, _hoisted_18, 2)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [step.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(codeList), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", null, _toDisplayString(index === 0 ? '激活码' : ''), 1), _createVNode(_component_el_input, {
          class: "custom-input",
          modelValue: item.code,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return item.code = $event;
          },
          placeholder: "请输入已购买产品的激活码",
          autocomplete: "off",
          onChange: function onChange($event) {
            return _unref(checkCodeLegal)(item, index);
          }
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]), _createElementVNode("span", _hoisted_22, _toDisplayString(item.name), 1), _unref(codeList).length > 1 ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "delete",
          onClick: function onClick($event) {
            return deleteCode(index);
          }
        }, _hoisted_25, 8, _hoisted_23)) : _createCommentVNode("", true), index === _unref(codeList).length - 1 ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "add",
          onClick: addCode
        }, _hoisted_27)) : _createCommentVNode("", true)]), item.code && typeof item.legal === 'boolean' && !item.legal ? (_openBlock(), _createElementBlock("p", _hoisted_28, _hoisted_31)) : _createCommentVNode("", true)]);
      }), 128))]), _hoisted_32, _createVNode(_component_el_button, {
        disabled: !_unref(codeLegal),
        class: "primary-button next",
        type: "primary",
        onClick: checkAllCode
      }, {
        default: _withCtx(function () {
          return [_hoisted_33];
        }),
        _: 1
      }, 8, ["disabled"])])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_34, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appData).appList, function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.activeCode
        }, [_createElementVNode("div", _hoisted_35, [_createElementVNode("p", _hoisted_36, [_createElementVNode("img", {
          src: item.logo,
          alt: ""
        }, null, 8, _hoisted_37), _createElementVNode("span", null, _toDisplayString(item.appName), 1)]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", null, [_hoisted_40, _createElementVNode("p", null, _toDisplayString(item.detail.availableTime || '-'), 1)]), _createElementVNode("div", null, [_hoisted_41, _createElementVNode("p", null, _toDisplayString(item.detail.availableAccounts || 0), 1)]), item.detail.bizNums ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_hoisted_43, _createElementVNode("p", null, _toDisplayString(item.detail.bizNums || 0) + "个", 1)])) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.detail.details, function (detail) {
          return _openBlock(), _createElementBlock("div", {
            class: "info desc",
            key: detail.detailName
          }, [_createElementVNode("p", _hoisted_44, _toDisplayString(detail.detailName), 1), _createElementVNode("p", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.detailValue, function (detailValue, index) {
            return _openBlock(), _createElementBlock("span", {
              key: index
            }, [_createTextVNode(_toDisplayString(detailValue), 1), index < detail.detailValue.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_45)) : _createCommentVNode("", true)]);
          }), 128))])]);
        }), 128))])]), item.protocal ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 0,
          modelValue: item.checked,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return item.checked = $event;
          },
          class: _normalizeClass(["custom-checkbox", {
            more: item.protocal.length > 1
          }]),
          "text-color": "#000"
        }, {
          default: _withCtx(function () {
            return [_hoisted_46, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.protocal, function (protocal, pidx) {
              return _openBlock(), _createElementBlock("a", {
                target: "_blank",
                href: protocal.url,
                key: protocal.name
              }, _toDisplayString(pidx ? '、' : '') + _toDisplayString(protocal.name), 9, _hoisted_47);
            }), 128))];
          }),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "class"])) : _createCommentVNode("", true)]);
      }), 128))]), _createElementVNode("div", _hoisted_48, [_createVNode(_component_el_button, {
        class: "normal-button",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return goStep(1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_49];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        disabled: !_unref(appChecked),
        class: "primary-button",
        type: "primary",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return goStep(3);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_50];
        }),
        _: 1
      }, 8, ["disabled"])])], 512), [[_vShow, step.value === 2]]), _withDirectives(_createElementVNode("div", _hoisted_51, [_createVNode(CompanyForm, {
        status: "new",
        "is-paid-create": isPaidCreate,
        onComfirm: handleNewCompany,
        onCancel: _cache[2] || (_cache[2] = function ($event) {
          return goStep(2);
        })
      }), _createVNode(_component_el_dialog, {
        width: "480px",
        height: "222px",
        title: "",
        modelValue: newWarnVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return newWarnVisible.value = $event;
        }),
        "custom-class": "custom-modal new-warn-modal",
        onClose: _cache[5] || (_cache[5] = function ($event) {
          return newWarnVisible.value = false;
        })
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_53, [_createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return newWarnVisible.value = false;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_54];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: comfirmNewCompany
          }, {
            default: _withCtx(function () {
              return [_hoisted_55];
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_hoisted_52];
        }),
        _: 1
      }, 8, ["modelValue"])], 512), [[_vShow, step.value === 3]]), _withDirectives(_createElementVNode("div", _hoisted_56, [_hoisted_57, isPaidCreate ? (_openBlock(), _createElementBlock("p", _hoisted_58, "完成创建企业")) : (_openBlock(), _createElementBlock("p", _hoisted_59, "您的申请已提交，灯塔运营同学将在一天内联系您")), isPaidCreate ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        class: "primary-button",
        type: "primary",
        onClick: goCompanyAppPage
      }, {
        default: _withCtx(function () {
          return [_hoisted_60];
        }),
        _: 1
      })) : _createCommentVNode("", true), !isPaidCreate ? (_openBlock(), _createBlock(_component_el_button, {
        key: 3,
        class: "primary-button",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = function ($event) {
          return goConsole('/console');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_61];
        }),
        _: 1
      })) : _createCommentVNode("", true), !isPaidCreate ? (_openBlock(), _createBlock(_component_el_button, {
        key: 4,
        class: "primary-button",
        type: "primary",
        onClick: _cache[7] || (_cache[7] = function ($event) {
          return goRouter('/');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_62];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_63, [_createElementVNode("p", null, [_hoisted_64, _createElementVNode("span", null, _toDisplayString(_unref(formState).name), 1)]), _createElementVNode("p", null, [_hoisted_65, _createElementVNode("span", null, _toDisplayString(_unref(formState).industryName), 1)]), _createElementVNode("p", null, [_hoisted_66, _createElementVNode("span", null, _toDisplayString(_unref(formState).contact), 1)]), _createElementVNode("p", null, [_hoisted_67, _createElementVNode("span", null, _toDisplayString(_unref(formState).phone), 1)])])], 512), [[_vShow, step.value === 4]])])]), _createVNode(_component_el_dialog, {
        width: "480px",
        height: "222px",
        title: "",
        modelValue: leaveWarnVisible.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
          return leaveWarnVisible.value = $event;
        }),
        "custom-class": "custom-modal leave-warn-modal",
        onClose: _cache[10] || (_cache[10] = function ($event) {
          return leaveWarnVisible.value = false;
        })
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_69, [_createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = function ($event) {
              return leaveWarnVisible.value = false;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_70];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: comfirmLeave
          }, {
            default: _withCtx(function () {
              return [_hoisted_71];
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_hoisted_68];
        }),
        _: 1
      }, 8, ["modelValue"])], 2);
    };
  }
});